import React from 'react';

const AuthLoadingScreen = ({ message = 'Loading your session...' }) => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      fontFamily: 'Arial',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #eee',
          borderTop: '4px solid #000',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px',
        }}></div>
        <p style={{ fontSize: '14px', color: '#666' }}>{message}</p>
      </div>
    </div>
  );
};

export default AuthLoadingScreen;